import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import config from './config';
import * as serviceWorker from './serviceWorker';

const initSentry = () => {
  if (config.sentryDSN === null) return;

  const loadSentry = () => {
    import('@sentry/browser').then((Sentry) => {
      Sentry.init({
        dsn: config.sentryDSN,
        environment: config.environment,
      });
    });
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadSentry, { timeout: 3000 });
  } else {
    window.setTimeout(loadSentry, 1);
  }
};

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);

initSentry();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
